module.exports = {
    ok:'確定',
    wky:'玩客雲',
    cancel:'取消',
    close:'關閉',
    yuan: '元',
    
    rule: 'Rule',
    note: 'Note',
    submit:'Submit',
    qq:'QQ number',
    phone:'Cell phone number',
    delete:'Delete',
    refresh:'Refresh',
    netblock:'Network is busy. Try again later.',
    view:'View',
    more:'More',
    less:'Less',
    loadm:'Load more',
    history:'History',
    rtn:'return',
    toofreq:'Operation Too Frequent',
    isee:'I see',
    cancel:'Cancel',
    confirm:'Confirm',
    onething_cloud:'OneThing Cloud',
    open:'Open',
    reload:'Reload',
    lang:'en',
    prompt:'prompt',
}


// WEBPACK FOOTER //
// ./js/src/i18n/common/hk.js